import { render } from "./TeamRosterThurA.vue?vue&type=template&id=24323473&scoped=true"
import script from "./TeamRosterThurA.vue?vue&type=script&scoped=true&lang=js"
export * from "./TeamRosterThurA.vue?vue&type=script&scoped=true&lang=js"

import "./TeamRosterThurA.vue?vue&type=style&index=0&id=24323473&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24323473"]])

export default __exports__